import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TPostContentBlockquoteReset, EPostContentBlockquoteActionType } from './types';

export const postContentBlockquoteReset: () => TPostContentBlockquoteReset =
  actionGenerator<EPostContentBlockquoteActionType.Reset>(EPostContentBlockquoteActionType.Reset);
